import React from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import "dayjs/locale/en";
import {
  ItemWrapper,
  ContentWrapper,
  Error,
  InputWrapper,
  InputContainer,
  ButtonsWrapper,
} from "../../styles";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import { CNYProps, FormInputs } from "../../../../../../types/walletTypes";
import { savedCNYData } from "../../../../redux/formDataSlice";
import { Input } from "../../../../../../components/common/Input";
import CountrySelect from "../../../../../../components/common/CountrySelect";
import { Button } from "../../../../../../components/common/Button";

const BusinessSenderForm = ({ handleNext, handlePrevious }: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);

  const { ...defaultValues } = getSavedData || {};

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormInputs>({
    defaultValues,
  });

  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  return (
    <ContentWrapper>
      <InputWrapper>
        <Controller
          name="senderBusinessRegisteredName"
          control={control}
          rules={{ required: "Business name is required" }}
          render={({ field }) => (
            <Input
              type="text"
              label="Registered business name"
              value={field.value}
              onChange={field.onChange}
              hasError={!!errors?.senderBusinessRegisteredName}
            />
          )}
        />
        {<Error>{errors?.senderBusinessRegisteredName?.message}</Error>}
      </InputWrapper>

      <InputWrapper>
        <Controller
          name="senderBusinessIdNumber"
          control={control}
          rules={{ required: "Business registration number is required" }}
          render={({ field }) => (
            <Input
              type="text"
              label="Business registration number"
              value={field.value}
              onChange={field.onChange}
              hasError={!!errors?.senderBusinessIdNumber}
            />
          )}
        />
        {<Error>{errors?.senderBusinessIdNumber?.message}</Error>}
      </InputWrapper>
      <InputWrapper>
        <Controller
          name="senderAddress.streetAddress"
          control={control}
          rules={{ required: "Business address is required" }}
          render={({ field }) => (
            <Input
              type="text"
              label="Business address"
              value={field.value}
              onChange={field.onChange}
              hasError={!!errors?.senderAddress?.streetAddress}
            />
          )}
        />
        {<Error>{errors?.senderAddress?.streetAddress?.message}</Error>}
      </InputWrapper>

      <ItemWrapper>
        <InputWrapper>
          <Controller
            name="senderAddress.city"
            control={control}
            rules={{ required: "City is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="City"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors?.senderAddress?.city}
              />
            )}
          />
          {<Error>{errors?.senderAddress?.city?.message}</Error>}
        </InputWrapper>

        <InputWrapper>
          <Controller
            name="senderAddress.state"
            control={control}
            rules={{ required: "State is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="State"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors?.senderAddress?.state}
              />
            )}
          />
          {<Error>{errors?.senderAddress?.state?.message}</Error>}
        </InputWrapper>
      </ItemWrapper>

      <ItemWrapper>
        <InputContainer>
          <InputWrapper>
            <Controller
              name="senderAddress.countryCode"
              control={control}
              rules={{ required: "Country is required" }}
              render={({ field }) => (
                <InputWrapper>
                  <CountrySelect
                    value={field.value}
                    onChange={field.onChange}
                    allCountries={true}
                    placeholder="Country"
                    lightBorder
                  />
                </InputWrapper>
              )}
            />
            {<Error>{errors?.senderAddress?.countryCode?.message}</Error>}
          </InputWrapper>
        </InputContainer>

        <InputWrapper>
          <Controller
            name="senderAddress.postcode"
            control={control}
            rules={{ required: "Postcode is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="Postcode"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors?.senderAddress?.postcode}
              />
            )}
          />
          {<Error>{errors?.senderAddress?.postcode?.message}</Error>}
        </InputWrapper>
      </ItemWrapper>

      <ButtonsWrapper>
        <Button
          onClick={handlePrevious}
          theme="alternate"
          height="48px"
          width="203px"
        >
          Back
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          label="Continue"
          height="48px"
        />
      </ButtonsWrapper>
    </ContentWrapper>
  );
};

export default BusinessSenderForm;
